/**
 * Value axes of the charts: a round step, the top line and the decimals of
 * the labels. The decimals follow the step, so no two labels read the same
 * (D2: a 0,5 step was labelled «0, 1, 1, 2, 2»).
 */

const STEPS = [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500];

function niceStep(raw: number): number {
  for (const s of STEPS) if (raw <= s) return s;
  return 1000;
}

/** Decimals that tell every multiple of `step` apart: 0,5 → 1, 0,05 → 2, 2 → 0. */
export function stepDigits(step: number): number {
  let d = 0;
  while (d < 3 && Math.abs(step * 10 ** d - Math.round(step * 10 ** d)) > 1e-9) d += 1;
  return d;
}

/** Axis of about `parts` steps up to `top`. */
export function valueScale(top: number, parts: number): { step: number; max: number; digits: number } {
  const step = niceStep(top / parts);
  return { step, max: Math.max(step, Math.ceil(top / step) * step), digits: stepDigits(step) };
}

/** Values of the axis lines: 0, step, … up to the top line. */
export function axisValues(scale: { step: number; max: number }): number[] {
  const out: number[] = [];
  for (let k = 0; k * scale.step <= scale.max + 1e-9; k += 1) out.push(k * scale.step);
  return out;
}
